import { ReactElement } from 'react';

const InfringementExtensionStep3AlertContent1 = (): ReactElement => (
  <div>
    <br />
    <p>
      For information on the options available to you, visit
      {' '}
      <a href="https://online.fines.vic.gov.au/Your-options" target="_blank" rel="noreferrer">
        your options
      </a>
      . If you would like to speak to someone, call Fines Victoria on
      {' '}
      <a href="tel:0392008111" title="Fines Victoria phone number">
        (03) 9200 8111
      </a>
      {' '}
      or
      {' '}
      <a href="tel:1300369819" title="Fines Victoria phone number">
        1300 369 819
      </a>
      {' '}
      (regional callers), Monday to Friday, 8am to 6pm (except public holidays).
    </p>
    <br />
    <p>
      If you do not deal with your outstanding fines, enforcement action may continue.
    </p>
  </div>
);

export default InfringementExtensionStep3AlertContent1;
